import React, { useState, useEffect } from 'react';

export default function Textarea({ error, rows, maxLength, className, onChange, label, required, ...props }) {
  const max = maxLength
  const [remainingChars, setRemainingChars] = useState(max || 200);
  const [inputText, setInputText] = useState('');

  const handleChange = (event) => {
    const text = event.target.value;
    if (max) {
      const charsRemaining = max - text.length;
      setRemainingChars(charsRemaining);
    }
    setInputText(text);

    // Invoke the onChange prop if provided
    if (onChange) {
      onChange(event);
    }
  };

  useEffect(() => {
    if (max) {
      const charsRemaining = max - inputText.length;
      setRemainingChars(charsRemaining);
    }
  }, [inputText, max]);

  return (
    <div className={` relative w-full`}>
      {label && (
        <label className="block text-sm text-[#4C4C66] mb-1 ml-2">{label}{required && ' *'}</label>
      )}
      <div>
        <textarea
          rows={rows || "4"}
          maxLength={max}
          onChange={handleChange}
          className={`w-full bg-[#F4F6FA] text-sm rounded-xl p-2 ${className}`}
          {...props}
        />
      </div>
      <div className='absolute top-0 right-0'>
        {max && (
          <span className="ml-2 text-xs text-[#B3B3B3] bottom-0">
            {remainingChars} characters remaining
          </span>
        )}
      </div>
      <div>
        {error && (
          <span className="ml-2 text-xs text-[#FF0000] bottom-0">
            * {error}
          </span>
        )}
      </div>

    </div>
  );
}
